import React from 'react'
import { Button, Tooltip } from 'antd'

import Styles from './ExamineeInfoModal.module.scss'
import {
  getChsiItemStatusDisplay,
  getChsiReportTypeLabel,
  shouldShowChsiItemDetailBtn
} from '../../common/chsiReportVerificationConstants'

function ChsiReportVerificationItemList ({ items, onViewDetail }) {
  if (!items?.length) {
    return null
  }

  return (
    <div className={ Styles.chsiItemList }>
      {
        items.map((item, index) => {
          const reportName = item.reportTypeName || getChsiReportTypeLabel(item.reportType)
          const { label, className } = getChsiItemStatusDisplay(item)
          const showDetail = shouldShowChsiItemDetailBtn(item) && onViewDetail
          const rowKey = item.verificationId || `${ item.reportType }-${ index }`

          return (
            <div className={ Styles.chsiItemRow } key={ rowKey }>
              <div className={ Styles.chsiItemMain }>
                <div className={ Styles.chsiItemTitle }>{ reportName }</div>
                {
                  item.fileName
                    ? (
                      <Tooltip title={ item.fileName }>
                        <div className={ Styles.chsiItemFileName }>附件：{ item.fileName }</div>
                      </Tooltip>
                    )
                    : null
                }
                <div className={ `${ className } ${ Styles.chsiItemStatus }` }>{ label }</div>
              </div>
              {
                showDetail
                  ? (
                    <Button
                      type="link"
                      size="small"
                      className={ Styles.chsiItemAction }
                      onClick={ () => onViewDetail(item.verificationId) }
                    >
                      查看详情
                    </Button>
                  )
                  : null
              }
            </div>
          )
        })
      }
    </div>
  )
}

export default ChsiReportVerificationItemList
